import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-white font-bold mb-4">About Profind.ca</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="hover:text-orange-500 transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-orange-500 transition-colors">Contact Us</Link></li>
              <li><Link to="/how-it-works" className="hover:text-orange-500 transition-colors">How It Works</Link></li>
            </ul>
          </div>

          {/* Homeowners */}
          <div>
            <h3 className="text-white font-bold mb-4">For Homeowners</h3>
            <ul className="space-y-2">
              <li><Link to="/providers" className="hover:text-orange-500 transition-colors">Find a Pro</Link></li>
              <li><Link to="/request-quote" className="hover:text-orange-500 transition-colors">Request Quote</Link></li>
              <li><Link to="/faq" className="hover:text-orange-500 transition-colors">FAQ</Link></li>
            </ul>
          </div>

          {/* Professionals */}
          <div>
            <h3 className="text-white font-bold mb-4">For Professionals</h3>
            <ul className="space-y-2">
              <li><Link to="/pricing" className="hover:text-orange-500 transition-colors">Pricing</Link></li>
              <li><Link to="/become-a-pro" className="hover:text-orange-500 transition-colors">Join as a Pro</Link></li>
              <li><Link to="/pro-quotes" className="hover:text-orange-500 transition-colors">Get Leads</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-white font-bold mb-4">Support</h3>
            <ul className="space-y-2">
              <li><Link to="/help" className="hover:text-orange-500 transition-colors">Help Center</Link></li>
              <li><Link to="/contact" className="hover:text-orange-500 transition-colors">Contact Us</Link></li>
              <li><Link to="/trust-safety" className="hover:text-orange-500 transition-colors">Trust & Safety</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_leadpay-system/artifacts/zoevafok_Profind-logo.png" 
                alt="Profind.ca" 
                style={{ height: '160px' }}
                className="w-auto brightness-0 invert"
              />
            </div>
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <Link to="/terms" className="hover:text-orange-500 transition-colors">Terms of Service</Link>
              <Link to="/privacy" className="hover:text-orange-500 transition-colors">Privacy Policy</Link>
              <Link to="/accessibility" className="hover:text-orange-500 transition-colors">Accessibility</Link>
            </div>
            <div className="text-sm">
              © 2025 Profind.ca. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;